import { AjaxError } from 'rxjs/ajax'
import { Observable, of, merge } from 'rxjs'
import { captureException, getErrorType, captureEndpointError } from 'helpers/errorHelpers'
import { setUnexpectedErrorActionCreator, handleUnauthorizedErrorActionCreator, handleNetworkErrorActionCreator } from 'actions/globalActions'
import { UNAUTHORIZED_STATUS_CODE, FORBIDDEN_STATUS_CODE, ABORTED_STATUS_CODE } from 'constants/ajax'
import { processForbiddenAjaxError } from 'helpers/ajaxHelpers'
import { catchError } from 'rxjs/operators'
import { Unobservable } from 'rxOperators/interfaces'

export const ajaxCatch = <
  Input, Output
> (selector: (err: AjaxError) => Observable<Output>) => (source: Observable<Input>) => {

    return source.pipe(
      catchError((error: Error | AjaxError) => {
        if (error instanceof AjaxError) {
          const { status, xhr } = error

          if (status === UNAUTHORIZED_STATUS_CODE) {
          // here we usually reset state, so anyway let's
            return of(handleUnauthorizedErrorActionCreator())
          }

          const output$ = selector(error)

          if (status === FORBIDDEN_STATUS_CODE) {
            return merge(
              processForbiddenAjaxError(xhr),
              output$
            )
          }

          if (status === ABORTED_STATUS_CODE) {
            return merge(
              of(handleNetworkErrorActionCreator()),
              output$,
            )
          }

          captureEndpointError(error)
          return output$
        }

        captureException(error)
        return of(setUnexpectedErrorActionCreator(getErrorType(error), error))
      }),
    )
  }

class Wrapper<Input, Output> {
  wrapped () {
    return ajaxCatch<Input, Output>('' as any)
  }
}
export type AjaxCatchExtraActions = NonNullable<Unobservable<ReturnType<ReturnType<Wrapper<null, null>['wrapped']>>>>
